import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

interface GraduatingCoin {
  name: string;
  marketCap: string;
  volume: string;
}

interface GraduatingCoinsCarouselProps {
  coins: GraduatingCoin[];
}

const GraduatingCoinsCarousel = ({ coins }: GraduatingCoinsCarouselProps) => {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4">about to graduate</h2>
      <Carousel className="w-full">
        <div className="flex items-center gap-4">
          <CarouselPrevious className="relative left-0 translate-y-0" />
          <div className="flex-1">
            <CarouselContent>
              {coins.map((coin, index) => (
                <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                  <div className="glass-card p-4 rounded-lg">
                    <h3 className="text-lg font-bold mb-2">{coin.name}</h3>
                    <div className="text-sm text-muted-foreground">
                      <p>Market Cap: {coin.marketCap}</p>
                      <p>Volume: {coin.volume}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
          </div>
          <CarouselNext className="relative right-0 translate-y-0" />
        </div>
      </Carousel>
    </div>
  );
};

export default GraduatingCoinsCarousel;